import React from "react";
import { Button } from "reactstrap";

function Pagination({ currentPage, totalPages, onNextClick, onPreviousClick }) {
  const pageNumbers = Array.from(
    { length: totalPages },
    (_, index) => index + 1
  );

  return (
    <div className="d-flex align-items-baseline">
      <Button color={"link"} onClick={() => onPreviousClick(currentPage)}>
        Précédent
      </Button>
      <span className={"mx-3"}>
        Page {currentPage} / {pageNumbers.length}
      </span>
      <Button color={"link"} onClick={() => onNextClick(currentPage)}>
        Suivant
      </Button>
    </div>
  );
}

export default Pagination;
